import { type CSSObject } from "@emotion/css";
import { Colors, Spacing } from "@snapchat/snap-design-system";

export const searchBarStyle: CSSObject = {
    alignItems: "center",
    color: Colors.Black.V100,
    display: "flex",
    fontWeight: 400,
    fontSize: 14,
};

export const searchInputStyle: CSSObject = {
    border: "none",
    flexGrow: 1,
    marginInlineStart: Spacing.XS,
    padding: "0 5px",
    ":focus": {
        outline: "none",
    },
    "&:disabled": {
        background: "transparent",
    },
};

export const searchInputWrapperStyle: CSSObject = {
    width: "100%",
    "> span": {
        display: "flex",
        width: "100%",
    },
};
